class Dropdown {
    constructor() {
        this.dropdown = ".js-dropdown";
        this.dropdownTriggers = document.querySelectorAll(".js-dropdown-trigger");
    }

    watchDropdown() {
        const { dropdownTriggers } = this;
        dropdownTriggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                const container = e.target.parentNode;
                if(container.classList.contains('dropdown__open')) {
                    container.classList.remove('dropdown__open');
                } else {
                    container.classList.add('dropdown__open');
                }
            });
        });
    }

    blurDropdown() {
        const { dropdownTriggers } = this;
        document.addEventListener("click", e => {
            if (!e.target.closest(this.dropdown)) {
                dropdownTriggers.forEach(trigger => {
                    trigger.previousSibling.previousSibling.checked = false;
                });
            }
        });
    }

    init() {
        this.watchDropdown();
        this.blurDropdown();
    }
}

export default Dropdown;



// WEBPACK FOOTER //
// ../project/craft/src/components/dropdown/dropdown.js